// File: frontend/src/components/SectionSubnav.js
// Version: 2.0 (Wave Translation — Design System & i18n)
// Date: 2026-10-22
// Назначение: полоса подраздела для арендатора fitenko.

import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useBranding } from '../context/BrandingContext';
import { useUiLanguage } from '../context/UiLanguageContext';
import { subnavFor } from '../config/fitenkoNav';
import { SUBNAV_ICONS } from '../config/subnavIcons';

const SectionSubnav = () => {
    const { user, navLinks, isAuthenticated, loading } = useAuth();
    const { isFitenko } = useBranding();
    const { t } = useUiLanguage();
    const location = useLocation();

    if (!isFitenko) return null;   // РУБЕЖ АРЕНДАТОРА
    if (loading || !isAuthenticated) return null;

    const items = subnavFor(user, navLinks, location.pathname);
    // Пустой список — полосы НЕТ, а не пустая полоса.
    if (!items || items.length === 0) return null;

    return (
        <nav className="section-subnav bg-card text-foreground border-b border-border">
            {items.map(item => {
                const IconComponent = SUBNAV_ICONS[item.key];
                return (
                    <NavLink
                        key={item.path}
                        to={item.path}
                        className={({ isActive }) => `section-subnav-item text-foreground hover:bg-muted ${isActive ? 'active nav-item--active' : ''}`}
                    >
                        <span className="section-subnav-item-icon inline-flex items-center">
                            {IconComponent ? <IconComponent size={15} strokeWidth={2} className="inline-block shrink-0" aria-hidden="true" /> : item.icon}
                        </span>
                        {t(`shell.dest.${item.key}`, item.label)}
                    </NavLink>
                );
            })}
        </nav>
    );
};

export default SectionSubnav;
